import { Flex, Heading } from "@radix-ui/themes";
import { type ReactNode } from "react";

interface Props {
  title: string;
  /** The page's actions ("New Event", "History"…), beside the title. */
  children?: ReactNode;
}

// The top of a track/club manager page. Moving between manager sections is
// the sidebar's job now (its Manage section), so this only names the page and
// holds its actions — left-aligned, next to the title.
export default function ManagerPageHeader({ title, children }: Props) {
  return (
    <Flex
      align="center"
      gap="4"
      wrap="wrap"
      px={{ initial: "3", sm: "4" }}
      pt="4"
      pb="2"
    >
      <Heading size="6">{title}</Heading>
      {children && (
        <Flex align="center" gap="2" wrap="wrap">
          {children}
        </Flex>
      )}
    </Flex>
  );
}
